export default {
  user: {
    ID: '用户ID',
    username: '用户名',
    addressList: '我的地址',
    cart: '我的購物車',
    orderList: '我的訂單',
    clearCache:'您的緩存資料已被清除，並將會登出！',
    logout:"登出",
    editPassword: '修改密碼',
    confirm: '確認',
    contact: '聯絡客戶服務主任'
  },
  credit: {
    title: 'KOL 熱購',
    myCredit: '我的積分',
    editPaymentMessage: '修改收款信息',
    history: '歷史記錄',
    credit: '積分',
    pay: '付款',
    buy: '購買',
    commission: '積分獎賞',
    refund: '退款',
    orderNumber: '訂單號碼:',
    noMoreData: '沒有更多數據',
    receiveType: '收款類型', 
    wechat: '微信',
    transfer: '轉帳',
    receiptName: '收款人',
    receiptNumber: '收款號碼',
    enterNumber: '請輸入收款微信／銀行卡號',
    beforeUploadConfirm: '－ 於上傳資料前，請確保收款類型，收款人以及號碼正確無誤',
    upload: '上傳',
    successAlert: '你已成功更改收款信息',
    failAlert: '請確保上述資料已填妥',
    remind: '提醒'
  },
  password: {
    oldPassword: '舊密碼',
    newPassword: '新密碼',
    enterOldPassword: '請在此輸入你的舊密碼',
    enterNewPassword: '請在此輸入你的新密碼',
    confirmPassword: '確認新密碼',
    remind: '－ 請確保密碼須為6個或以上位字元，並建議包含大寫和小寫字母以及數字',
    editPassword: '修改密碼',
    successAlert: '你已成功更改密碼',
    failAlert: '請確保你已填寫所有資料，及新的密碼與確認密碼相乎',
  }

}


// WEBPACK FOOTER //
// ./src/Account/langs/zh_hk/index.js